import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { itemCategoryRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const itemCategoryRouteMetadata: IRouteMetadataObj<
  typeof itemCategoryRoutesObj
> = {
  list: {
    title: "basicInfo.index.title",
    description: "empty",
    lazy: () => import("@pages/basicInfo/itemCategory/table/page"),
    mode: "index",
    type: "main",
    icon: "Information2Line",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "basicInfo.itemCategoryManagement.create.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/itemCategory/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "basicInfo.itemCategoryManagement.edit.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/itemCategory/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
};

export const itemCategoryRoutes = createRoute<typeof itemCategoryRoutesObj>(
  itemCategoryRoutesObj,
  itemCategoryRouteMetadata,
);
